/*
 * ATD - Countdown 1 web component
 *
 * Lee data-mode ("exact" | "duration"):
 *   - exact:    data-end-unix (segundos UTC desde epoch). Endtime = end_unix * 1000.
 *   - duration: data-duration-seconds. Endtime = pageLoad + duration_seconds * 1000.
 *
 * Tick cada segundo, actualiza DD:HH:MM:SS con padStart.
 * Al expirar lee data-on-expire ("hide" | "message"):
 *   - hide:    oculta toda la sección padre.
 *   - message: oculta el bloque del timer y muestra .atd-countdown1__expired.
 */
class AtdCountdown1 extends HTMLElement {
  connectedCallback() {
    const mode = this.dataset.mode;

    if (mode === 'exact') {
      const endUnix = Number(this.dataset.endUnix);
      this.endTimeMs = endUnix * 1000;
    } else {
      const durationSec = Number(this.dataset.durationSeconds);
      this.endTimeMs = Date.now() + durationSec * 1000;
    }

    this.onExpireAction = this.dataset.onExpire || 'hide';

    this.digitNodes = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.timerNode = this.querySelector('.atd-countdown1__timer');
    this.expiredNode = this.querySelector('.atd-countdown1__expired');

    this.tick();
    this.intervalId = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  tick() {
    const remainingMs = Math.max(0, this.endTimeMs - Date.now());

    if (remainingMs === 0) {
      this.renderUnits(0, 0, 0, 0);
      this.handleExpire();
      return;
    }

    const totalSec = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSec / 86400);
    const hours = Math.floor((totalSec % 86400) / 3600);
    const minutes = Math.floor((totalSec % 3600) / 60);
    const seconds = totalSec % 60;

    this.renderUnits(days, hours, minutes, seconds);
  }

  renderUnits(d, h, m, s) {
    if (this.digitNodes.days) this.digitNodes.days.textContent = String(d).padStart(2, '0');
    if (this.digitNodes.hours) this.digitNodes.hours.textContent = String(h).padStart(2, '0');
    if (this.digitNodes.minutes) this.digitNodes.minutes.textContent = String(m).padStart(2, '0');
    if (this.digitNodes.seconds) this.digitNodes.seconds.textContent = String(s).padStart(2, '0');
  }

  handleExpire() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    if (this.onExpireAction === 'message' && this.expiredNode) {
      if (this.timerNode) this.timerNode.hidden = true;
      this.expiredNode.hidden = false;
    } else {
      // Ocultar el contenedor raíz. El contenedor se identifica con el
      // atributo data-countdown-root (genérico — funciona para la sección
      // atd-countdown1, el block atd-countdown1 y la barra atd-promo-bar1).
      // Fallback a .atd-countdown1 por compatibilidad.
      const root = this.closest('[data-countdown-root]') || this.closest('.atd-countdown1') || this;
      root.hidden = true;
    }
  }
}

if (!customElements.get('atd-countdown1')) {
  customElements.define('atd-countdown1', AtdCountdown1);
}
